const breakpoints = {
  mobile: 0,
  mobileLarge: 460,
  // targeting all devices
  tablet: 737,
  // targeting devices that are larger than the iPhone 6 Plus (which is 736px in landscape mode)
  desktop: 1025,
  // targeting devices that are larger than the iPad (which is 1024px in landscape mode)
  desktopLarge: 1600,
};

export default breakpoints;
